import { Clinic } from 'lib/documents/clinic';

export type UnlockPipelineType = 'clinic' | 'payment';
export interface UnlockPipeline {
  label: string;
  value: UnlockPipelineType;
  include: (args: { clinic: Clinic }) => boolean;
}

export const ASSESSMENT_UNLOCK_PIPELINES: UnlockPipeline[] = [
  {
    label: 'Activate assessment in organisation',
    value: 'clinic',
    include: () =>
      true
  }
];
